import React, { useState } from "react";
import {
  Row,
  Col,
  InputGroup,
  DropdownButton,
  Dropdown,
  Table,
  Modal,
  Button,
  FormControl,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import lodash from "lodash";
import { getDifferenceBetweenArrays } from "../../helpers/stubs";
// import CandidateSearchBar from "../../components/AdminCandidateSearch/AdminCandidateSearch";
import { showModal } from "../../Slices/sessionSlice";
import { newAlert } from "../../Slices/alertSlice";
function EditCandidateModal({ data }) {
  const {
    role,
    name,
    _id,
    organization,
    supervisorsOld,
    candidatesSupervisingOld,
    currencyOld,
    weeklyHoursOld,
    hourlyRateOld,
    positionOld,
    sessionUserRole,
    editCandidate,
    CandidateSearchBar,
  } = data;
  const dispatch = useDispatch();
  // const [currencyModal, setCurrencyModal] = useState(currency || "INR");
  const roles = ["Supervisor", "Candidate", "OrgAdmin"];
  let roleReceived = role;
  if (sessionUserRole === "super-admin") {
    roleReceived = null;
  }
  const [selectedRole, setselectedRole] = useState(roleReceived);
  const [candidatesSupervising, setCandidatesSupervising] = useState(
    candidatesSupervisingOld || []
  );
  const [supervisors, setSupervisors] = useState(supervisorsOld || []);
  const [position, setPosition] = useState(positionOld);
  const [currency, setCurrency] = useState(currencyOld);
  const [weeklyHours, setWeeklyHours] = useState(weeklyHoursOld);
  const [hourlyRate, setHourlyRate] = useState(hourlyRateOld);

  const validateAndSetPayload = () => {
    const payload = {};
    if (weeklyHours !== weeklyHoursOld) {
      payload.weeklyHours = weeklyHours;
    }
    if (hourlyRate !== hourlyRateOld) {
      payload.hourlyRate = hourlyRate;
    }
    if (currency !== currencyOld) {
      payload.currency = currency;
    }
    if (position !== positionOld) {
      payload.position = position;
    }
    if (selectedRole !== role && selectedRole !== null) {
      payload.role = selectedRole;
    }
    if (!lodash.isEqual(supervisors, supervisorsOld)) {
      if (sessionUserRole === "super-admin") {
        payload.supervisors = supervisors.map((supervisor) => supervisor._id);
      } else {
        payload.supervisors = supervisors;
      }
    }
    if (!lodash.isEqual(candidatesSupervising, candidatesSupervisingOld)) {
      if (sessionUserRole === "super-admin") {
        payload.candidatesSupervising = candidatesSupervising.map(
          (candidate) => candidate._id
        );
      } else {
        payload.candidatesSupervising = candidatesSupervising;
      }
    }
    if (lodash.isEmpty(payload)) {
      return [null, "No Changes Detected"];
    }
    if (sessionUserRole === "super-admin") {
      payload.organizationId = organization._id;
    }
    payload.candidateId = _id;
    return [payload, null];
  };

  const editUser = () => {
    const [payload, error] = validateAndSetPayload();
    if (error) {
      return dispatch(
        newAlert({
          type: "danger",
          message: error,
        })
      );
    }
    console.log("payload", payload);
    dispatch(editCandidate(payload));
  };

  return (
    <Modal
      show={true}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      top
      autoFocus
      animation
    >
      <Modal.Header>
        <Row className="w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Candidate : {name}
          </Modal.Title>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {selectedRole === "Supervisor" && (
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="edit-Position">
                    CandidatesSupervising
                  </InputGroup.Text>
                  <CandidateSearchBar
                    defaultSelected={candidatesSupervisingOld}
                    multiple={true}
                    handleSelection={setCandidatesSupervising}
                    placeholder={"Assign Candidates For Supervisor"}
                    organization={organization}
                  />
                </InputGroup>
              </Col>
            </Row>
          )}
          {selectedRole === "Candidate" && (
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="edit-organisation">
                    Supervisors
                  </InputGroup.Text>
                  <CandidateSearchBar
                    defaultSelected={supervisorsOld}
                    multiple={true}
                    handleSelection={setSupervisors}
                    placeholder={"Assign Supervisor For Candidate"}
                    organization={organization}
                  />
                </InputGroup>
              </Col>
            </Row>
          )}
        </Row>
        <Row>
          <Col>
            <InputGroup className="mb-3">
              <InputGroup.Text id="edit-Position">Position</InputGroup.Text>
              <FormControl
                id="basic-url"
                aria-describedby="basic-addon3"
                placeholder={position || "Not Set"}
                onChange={(e) => setPosition(e.target.value)}
                value={position}
              />
            </InputGroup>
          </Col>
        </Row>
        {sessionUserRole === "super-admin" && (
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <InputGroup.Text id="edit-weeklyHours">
                  WeeklyHours
                </InputGroup.Text>
                <FormControl
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  placeholder={weeklyHours || "Not Set"}
                  value={weeklyHours}
                  onChange={(e) => setWeeklyHours(e.target.value)}
                  type="number"
                />
              </InputGroup>
            </Col>
          </Row>
        )}
        {sessionUserRole === "super-admin" && (
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <InputGroup.Text id="edit-hourlyRate">
                  HourlyRate
                </InputGroup.Text>
                <FormControl
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  placeholder={hourlyRate || "Not Set"}
                  value={hourlyRate}
                  onChange={(e) => setHourlyRate(e.target.value)}
                  type="number"
                />
              </InputGroup>
            </Col>
          </Row>
        )}
        {sessionUserRole === "super-admin" && (
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <DropdownButton
                  variant="outline-secondary"
                  title={currency || "Currency"}
                  id="input-group-dropdown-1"
                >
                  <Dropdown.Item onClick={() => setCurrency("INR")}>
                    INR
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCurrency("USD")}>
                    USD
                  </Dropdown.Item>
                </DropdownButton>
              </InputGroup>
            </Col>
          </Row>
        )}
        {sessionUserRole === "super-admin" && (
          <ul
            id="list"
            className="device_title_outer"
            style={{
              display: "flex",
              listStyle: "none",
            }}
          >
            <lable for="list">Select Role:</lable>
            {roles.map((role) => (
              <li className="device_title_inner" style={{ marginLeft: "10px" }}>
                <input
                  type="radio"
                  eventKey={role}
                  value={role}
                  name="item"
                  id={role}
                  checked={selectedRole === role}
                  className={"form-check-label"}
                  onChange={(e) => {
                    setselectedRole(e.target.value);
                    setCandidatesSupervising(candidatesSupervisingOld);
                    setSupervisors(supervisorsOld);
                  }}
                />
                <label style={{ marginLeft: "3px" }} for={role}>
                  {role}
                </label>
              </li>
            ))}
          </ul>
        )}
        <Row>
          <Col
            sm="12"
            style={{
              marginLeft: "29vw",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Button variant="outline-success" onClick={() => editUser()}>
              Yes
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => {
                dispatch(showModal(null));
              }}
              style={{ marginLeft: "80px" }}
            >
              No
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EditCandidateModal;
